// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_j4-6";
export var emphasizeQuantity = "_j4-3";
export var flatBottomCorners = "_j4-5";
export var productImage = "_j4-0";
export var quantityContainer = "_j4-2";
export var tooltip = "_j4-1";
export var wrapAndEllipsesOverflow = "_j4-4";